import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    border: "1px solid #386E5B",
    textAlign: "center",
  },
  tableCell: {
    padding: "5px 0px",
    border: "1px solid #386E5B",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminCustomerDetail() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const region = useSelector((state) => state.customerRegion.data);
  const group = useSelector((state) => state.customerGroup.data);
  const priceType = useSelector((state) => state.priceType.data);
  const data = useSelector((state) => state.customer.data);

  // Local State
  const [formData, setFormData] = useState({
    customerCode: "",
    typeOfCustomer: "",
    customerName: "",
    address: "",
    customerRegionId: "",
    timeOfPayment: "",
    pic: "",
    customerGroupId: "",
    priceTypeId: "",
    description: "",
  });
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          customerCode: data.docs[x].customerCode
            ? data.docs[x].customerCode
            : "",
          typeOfCustomer: data.docs[x].typeOfCustomer
            ? data.docs[x].typeOfCustomer
            : "",
          customerName: data.docs[x].customerName
            ? data.docs[x].customerName
            : "",
          address: data.docs[x].address ? data.docs[x].address : "",
          customerRegionId: data.docs[x].customerRegionId
            ? data.docs[x].customerRegionId._id
            : "",
          customerRegionName: data.docs[x].customerRegionId
            ? data.docs[x].customerRegionId.regionName
            : "",
          timeOfPayment: data.docs[x].timeOfPayment
            ? data.docs[x].timeOfPayment
            : "",
          pic: data.docs[x].pic ? data.docs[x].pic : "",
          customerGroupId: data.docs[x].customerGroupId
            ? data.docs[x].customerGroupId._id
            : "",
          customerGroupName: data.docs[x].customerGroupId
            ? data.docs[x].customerGroupId.groupName
            : "",
          priceTypeId: data.docs[x].priceTypeId
            ? data.docs[x].priceTypeId._id
            : "",
          priceTypeName: data.docs[x].priceTypeId
            ? data.docs[x].priceTypeId.typeName
            : "",
          description: data.docs[x].description ? data.docs[x].description : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL CUSTOMER
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE CUSTOMER
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 20,
                style: { background: "white" },
                readOnly: true,
              }}
              required
              size="small"
              name="customerCode"
              value={formData.customerCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TIPE CUSTOMER
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="typeOfCustomer"
              value={formData.typeOfCustomer}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value="cn">CN</MenuItem>
              <MenuItem value="non-cn">non-cn</MenuItem>
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              NAMA CUSTOMER
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="customerName"
              value={formData.customerName}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              ALAMAT
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="address"
              value={formData.address}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              REGION
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="customerRegionId"
              value={formData.customerRegionId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.customerRegionName &&
                formData.customerRegionName.length > 0 && (
                  <MenuItem value={formData.customerRegionId}>
                    {formData.customerRegionName}
                  </MenuItem>
                )}
              {region.docs.length > 0 ? (
                region.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.regionName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TENOR PEMBAYARAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="timeOfPayment"
              value={formData.timeOfPayment}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PIC
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="pic"
              value={formData.pic}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              GROUP
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="customerGroupId"
              value={formData.customerGroupId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.customerGroupName &&
                formData.customerGroupName.length > 0 && (
                  <MenuItem value={formData.customerGroupId}>
                    {formData.customerGroupName}
                  </MenuItem>
                )}
              {group.docs.length > 0 ? (
                group.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.groupName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TIPE HARGA
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="priceTypeId"
              value={formData.priceTypeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.priceTypeName && formData.priceTypeName.length > 0 && (
                <MenuItem value={formData.priceTypeId}>
                  {formData.priceTypeName}
                </MenuItem>
              )}
              {priceType.docs.length > 0 ? (
                priceType.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.typeName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              Deskripsi
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ style: { background: "white" }, readOnly: true }}
              required
              size="small"
              name="description"
              value={formData.description}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/customer")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
